export * from './IconShieldGradient';
export { default as IconShieldGradient } from './IconShieldGradient';
